// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ec275f3c","239":"bae831d3","453":"05f8c4a7","553":"4f8e1296"}[chunkId] + ".chunk.js";
};